export default function getCkHtml(field) {
  if (!field) return undefined;
  if (typeof field === "string") return field;
  if (typeof field === "object") {
    return field.rawHtml ?? field.html ?? undefined;
  }
  return undefined;
}